<template>
  <div>
    <b-modal
      id="confirm-modal"
      hide-header
      :ok-title="actionName"
      :ok-disabled="!envChecked"
      ok-variant="danger"
      @ok="handleOk"
      @hidden="resetModal"
    >
      <p v-html="messageHtml">
      </p>

      <p class="mt-1" v-if="hasDescription">
        {{ description }}
      </p>

      <b-form-checkbox
        v-model="envChecked"
        class="mt-3"
      >
        <!-- I understand, the action will be executed on production. -->
        Execute this command on <span class="confirmation-window-prod">production</span>.
      </b-form-checkbox>
    </b-modal>
  </div>
</template>

<script>
import { setProdConfirmationWindow } from '../service/confirm';
import { escapeHtml } from '../util';

export default {
  name: 'ProdConfirmationWindow',

  data() {
    return {
      messageHtml: null,
      description: null,
      actionName: null,
      onConfirmed: null,

      envChecked: false,
    };
  },

  computed: {
    hasDescription() {
      return this.description !== null;
    },
  },

  created() {
    setProdConfirmationWindow(this);
  },

  methods: {
    show(page, messageTemplate, actionName, onConfirmed, paramObject) {
      const escapedMessageTemplate = escapeHtml(messageTemplate);

      this.messageHtml = escapedMessageTemplate.replace('{env}', 'on&nbsp;<span class="confirmation-window-prod">production</span>');
      this.actionName = actionName;
      this.onConfirmed = onConfirmed;
      this.envChecked = false;

      if(paramObject !== undefined && paramObject.description !== undefined) {
        this.description = paramObject.description;
      } else {
        this.description = null;
      }

      page.$bvModal.show('confirm-modal');
    },

    handleOk() {
      if(this.onConfirmed !== null) {
        this.onConfirmed();
      }
    },

    resetModal() {
      this.messageHtml = null;
      this.actionName = null;
      this.onConfirmed = null;
      this.envChecked = false;
    },
  },
};
</script>

<style>
  .confirmation-window-prod {
    color: #ff0000;
    font-weight: bold;
  }
</style>
